import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'billingGroups',
  components: {
    backButton: require('@/components/backButton/backButton.vue').default,
    CircleSpinner: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default
  },
  data: function () {
    return {
      billingGroups: []
    };
  },
  watch: {},
  beforeUnmount() {},
  created() {
    this.billingGroups = [];
    this.$store.dispatch('resetReadingsLocalDB').then(() => {
      this.getSettings();
      this.getCommonData();
      this.getBillingGroups();

      if (this.$store.state.settings.spotBilling) this.getSpotBillReports();
    });
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getBillingGroups() {
      axios
        .post('/CaptureMeterReading/GetBillingGroups')
        .then((response) => {
          if (!response.data.items || response.data.items.length == 0) {
            this.$router.push('/login');
            this.$alertMsg(this.$t('captureMR.NoBillingGroupsFound'), 4);
            return;
          }

          this.billingGroups = response.data.items;

          this.$store.state.readingsLocalDB
            .get(`billingGroups`)
            .then((doc) => {
              this.$store.state.readingsLocalDB.put({
                _id: doc._id,
                _rev: doc._rev,
                billingGroups: this.billingGroups
              });
            })
            .catch((err) => {
              if (err.status == 404) {
                this.$store.state.readingsLocalDB.put({
                  _id: `billingGroups`,
                  billingGroups: this.billingGroups
                });
              }
            });
        })
        .catch((e) => {
          return false;
        });
    },
    onSelectBillGroup(item) {
      //console.log(item);
      var route = `/captureMeterReadingsBgBooks/${item.id}`;
      this.$router.push(route);
    },
    getClassBillGroups(id) {
      return 'md-primary';
    },
    getSettings() {
      axios.post('/Utility/GetSettings').then((response) => {
        if (response.data.data.status == 0) {
          this.$store.commit('setSettings', { data: response.data.value });
        }
      });
    },
    getCommonData() {
      axios.post('/CaptureMeterReading/GetCommonData').then((response) => {
        this.$store.commit('setCaptureReadingsCommonData', { data: response.data });
        this.saveCommonDataIntoLocalDb(response.data);
      });
    },
    getSpotBillReports() {
      axios
        .get('/CaptureMeterReading/GetSpotBillReports')
        .then((response) => {
          this.$store.commit('setCaptureReadingsSpotBillReports', { items: response.data.items });
        })
        .catch((e) => {
          return false;
        });
    },
    saveCommonDataIntoLocalDb(data) {
      this.$store.state.readingsLocalDB
        .get(`captureReadingCommonData`)
        .then((doc) => {
          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            data: data
          });
        })
        .catch((err) => {
          if (err.status == 404) {
            this.$store.state.readingsLocalDB.put({
              _id: `captureReadingCommonData`,
              data: data
            });
          }
        });
    }
  }
};
